import { render } from "./TanSuoView.vue?vue&type=template&id=599f4b2a&scoped=true&ts=true"
import script from "./TanSuoView.vue?vue&type=script&lang=ts"
export * from "./TanSuoView.vue?vue&type=script&lang=ts"

import "./TanSuoView.vue?vue&type=style&index=0&id=599f4b2a&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599f4b2a"]])

export default __exports__